import { View, Text } from "react-native";
import React from "react";
import { ShopPage } from "lib/sanity.types";
import SectionTitle from "./components/SectionTitle";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import WhiteText from "components/WhiteText";
import { Image } from "expo-image";
import { getSanityImage } from "lib/sanity";
import Container from "components/Container";
import classNames from "classnames";

const Perks = ({
  shopPage,
  hasFaqs,
}: {
  shopPage: ShopPage;
  hasFaqs: boolean;
}) => {
  const { data: branding } = useFetchTenantBrandingQuery();

  return (
    <View
      className={classNames("px-4 md:px-16 py-4 lg:pt-4", {
        "lg:pb-32": hasFaqs,
        "lg:pb-52": !hasFaqs,
      })}
      style={{ backgroundColor: branding?.primaryColor }}
    >
      <Container className="relative">
        <SectionTitle title="Perks" color="white" />

        <View className="mb-4">
          <WhiteText category="h3">Your plan includes</WhiteText>
        </View>

        <View className="grid gap-4 grid-cols-1 lg:grid-cols-4 lg:absolute lg:-bottom-48">
          {shopPage.perks.map((perk) => (
            <View
              key={perk._key}
              style={{
                backgroundColor:
                  shopPage.perksBoxColor?.hex || branding?.secondaryColor,
              }}
              className="rounded-lg px-4 py-6"
            >
              <Image
                source={{ uri: getSanityImage(perk.icon.asset._ref) }}
                responsivePolicy="initial"
                style={{ width: 50, height: 50 }}
              ></Image>
              <Text>{perk.description}</Text>
            </View>
          ))}
        </View>
      </Container>
    </View>
  );
};

export default Perks;
